export default "__VITE_ASSET__D_5aFqHR__"